const Title = ({children}: {children: string}) => <h2 className={styles.title}>{children}</h2>;

export const Subtitle = ({children}: {children: string}) => <div className={styles.subtitle}>{children}</div>;

export const LargeTitle = ({children, className = ''}: {children: string; className?: string}) => (
  <h1 className={`${styles.largeTitle} ${className}`}>{children}</h1>
);

const baseText = `text-darker-gray font-thin text-center`;

const styles = {
  title: `
    text-4xl mt-8 ${baseText}
    max-[576px]:text-2xl max-[576px]:mt-4
  `,
  subtitle: `
    text-2xl mb-2 ${baseText}
  `,
  largeTitle: `
    text-[40px] m-5 ${baseText}
    max-[576px]:text-[30px]
  `,
};

export default Title;
